import { render, staticRenderFns } from "./LoginScreenDogU.vue?vue&type=template&id=08c40d37&"
import script from "./LoginScreenDogU.vue?vue&type=script&lang=js&"
export * from "./LoginScreenDogU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports